import {ArticleUpdateJobItem} from '../types';

const getArticleUpdateJobBasketItemMock: ArticleUpdateJobItem[] = [
  {
    id: 'a40c514f-ae8f-43cc-94c9-49e9f1750747',
    articleUpdateJobId: '9d9576a8-fe58-4d04-b57f-9b3933589c94',
    state: 'BASKET',
    manufacturerId: '2662a666-9d21-4625-8927-608477d4e7cc', // TEST manufacturer
    catalogNumber: 'Cat 4',
    createdAt: '2025-06-06T11:23:52.709Z',
    createdBy: '98d07dd3-9946-48ad-8392-fb2d77739e7e',
  },
];

export const metadaWarehouseArticleUpdateJobBasketItemApiMock = {
  getArticleUpdateJobBasketItemMock,
};
